import ajaxProxy from "../globs/ajax-proxy";
import gaPush, { gaSetUser } from "../../src/globs/utils/google-analytics";
import subscribeNotifications from "./firebase-notifications";

export default function login({
  // email,
  // google_user_id,
  // username,
  targetUrl,
  // tokenId,
  clientId,
  credential,
  select_by,
}) {
  return (dispatch) => {
    console.log("targetUrl ", targetUrl);
    dispatch(loginPending());

    ajaxProxy
      .login({
        // email,
        // google_user_id,
        // username,
        targetUrl,
        // tokenId,
        clientId,
        credential,
        select_by,
      })
      .then((response) => {
        const userData = {
          // username: response.data.data.username,
          // email: response.data.data.email,
          // google_user_id: response.data.data.google_user_id,
          // tokenId: response.data.data.tokenId,
          clientId: response.data.data.clientId,
          credential: response.data.data.credential,
          select_by: response.data.data.select_by,
        };
        // console.log('response>>>>>>>>>', response);
        gaSetUser(userData);
        // gaPush("event", {
        //   category: "Login",
        //   action: "Login",
        //   label: `${response.data.data.google_user_id}`,
        // });
        // dispatch(subscribeNotifications(response.data.data));
        dispatch(loginConfigureUser(userData));

        // console.log('response >>>', response);
        dispatch(loginFulfilled(response));
        // dispatch(setLocalStorage(response));
      })
      .catch((error) => {
        dispatch(loginRejected(error));
        dispatch(loginFulfilled());
      });
  };
}

function loginPending() {
  return {
    type: "login_PENDING",
    payload: {},
  };
}

function loginFulfilled(response) {
  // console.log('login response', response)
  return {
    type: "login_FULFILLED",
    payload: response,
  };
}

export function loginConfigureUser(userData) {
  return () => {
    gaSetUser(userData);
  };
}

function loginRejected(errorMessage) {
  return {
    type: "login_REJECTED",
    payload: {
      loginErrorMessage: errorMessage,
    },
  };
}

// function setLocalStorage(response) {
//   localStorage.setItem("__token", response.data.data._token);
// }
